import { QueryClient } from '@tanstack/react-query';

/**
 * 全域 QueryClient。
 * - staleTime 30 秒：客戶列表 / 詳情在短時間內不重打。
 * - retry 1：避免短暫網路抖動就失敗。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
